import { useTranslation } from "react-i18next";
import { TextAreaField } from "../../../../fields/base/TextAreaField";
import { css } from "../../../../../../styled-system/css";
import { HoverInfo } from "../../../basic/Tooltip";

const AdPlanUpdateAnnotationField = ({ state, onChange }) => {
  const { t } = useTranslation(["advertising"]);
  return (
    <TextAreaField
      label={
        <span
          className={`${css({
            color: "#73706E",
          })} fs-standard`}
        >
          {t(($) => $.advertising["Comments (optional)"])}{" "}
          <HoverInfo iconCss={{ color: "grey", display: "inline", paddingStart: "small" }}>
            {t(
              ($) =>
                $.advertising[
                  "If comments are added below a new annotation will be created. These annotations are shown on dashboard charts and in the Impact Analysis table."
                ],
            )}
          </HoverInfo>
        </span>
      }
      className={css({ width: "full", paddingX: "2rem" })}
      value={state.adUpdateAnnotation}
      onChange={(value) => onChange({ adUpdateAnnotation: value })}
      placeholder={t(($) => $.advertising["Describe what changes you made..."])}
    />
  );
};

export default AdPlanUpdateAnnotationField;
